import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'Llevaba años batallando con mis hijos a la hora de cenar. Con esta guía en 3 días ya había un cambio enorme. ¡Increíble!',
    name: 'María G. — Ciudad de México',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=1976&auto=format&fit=crop'
  }, {
    text: 'No podía dormir bien y tenía grasa abdominal que no bajaba. Seguí el protocolo 21 días y los cambios fueron reales.',
    name: 'Carlos M. — Bogotá',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1974&auto=format&fit=crop'
  }, {
    text: 'Pensé que era otro e-book más. Pero el método es diferente, práctico y con fundamento. Lo recomiendo a todos.',
    name: 'Ana R. — Madrid',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=1961&auto=format&fit=crop'
  }];
  return <section className="py-24 bg-brand-cream" data-id="element-199">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-200">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-201">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-brand-charcoal mb-4" data-id="element-202">
            Lo que dicen nuestros lectores
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-203">
          {testimonials.map((testimonial, index) => <motion.div key={index} className="bg-white rounded-2xl p-8 shadow-lg shadow-black/5 flex flex-col" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} data-id="element-204">
              <div className="flex gap-1 mb-6" data-id="element-205">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-206" />)}
              </div>

              <p className="text-brand-charcoal/80 italic mb-8 flex-grow text-lg" data-id="element-207">
                "{testimonial.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-100" data-id="element-208">
                <img src={testimonial.image} alt={testimonial.name} className="w-12 h-12 rounded-full object-cover" data-id="element-209" />
                <span className="font-medium text-brand-charcoal text-sm" data-id="element-210">
                  {testimonial.name}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}